import React, { useState, useEffect } from "react";
import Keyword from "./Keyword";
import "./KeywordContainer.css";
import environment from "../Environment";
import { commitLocalUpdate } from "react-relay";
import { useNavigate, Link } from "react-router-dom";
import { useTheme } from "../contexts/ThemeContext";

function KeywordContainer(props) {
    const navigate = useNavigate();
    const theme = useTheme();
    const [isTagChanged, setIsTagChaged] = useState(false);
    const { metaSourceName } = props.settings;
    const settings = props.settings;
    const user = props.user;

    const { tagData } = props.settings;

    function updateTagData(tagData) {
        const tagDataObject = JSON.parse(tagData);
        let tagDataString = JSON.stringify(tagDataObject);
        const tagArr = Object.values(tagDataObject);
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(tagDataString, "tagData");
            record.setValue(tagArr, "selectedLeads");
            record.setValue("{}", "tagData");
        });
    }

    function onFindArticlesClick(e) {
        e.preventDefault();
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(false, "isAdvancedSearch");
            record.setValue("Trending topics from ", "metaDescription");
            record.setValue(metaSourceName, "metaSourceName");
            record.setValue(false, "isRightNavActivated");
        });
        updateTagData(tagData);
        navigate("/trending");
    }

    function onFeedgramAnalysisLinkClick(e) {
        e.preventDefault();
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue("{}", "tagData");
        });
        navigate("/terms");
    }

    useEffect(() => {
        if (tagData == "{}") {
            setIsTagChaged(false);
        } else {
            setIsTagChaged(true);
        }
    }, [tagData]);

    return (
        <div className="keyword-container">
            <div className={`find-trending-articles-keyword`}>
                <div className={`tag-container-info`}>
                    <h3> {metaSourceName}</h3>
                </div>
                <button
                    disabled={!isTagChanged}
                    className={`btn-find-articles-topics btn-find-articles-${isTagChanged}`}
                    onClick={onFindArticlesClick}
                >
                    {" "}
                    Find Articles{" "}
                </button>
            </div>

            <div className="info-wrapper">
                {/* <span> Important keywords from the latest articles </span> */}
                <small>
                    &#128161; Select one or more keywords and tap Find Articles.{" "}
                    <a href="#"> Know More </a>
                </small>
            </div>
            <div className="keyword-box">
                {props.tagList.length != 0 ? (
                    <>
                        {props.tagList.map((value, key) => (
                            <div key={key}>
                                <Keyword
                                    className={`xxxx`}
                                    id={key}
                                    value={value}
                                    settings={settings}
                                    user={user}
                                />
                            </div>
                        ))}
                    </>
                ) : (
                    <>
                        {" "}
                        <p>
                            {" "}
                            It seems there is no sufficient related content for
                            Feed Analytics!{" "}
                        </p>
                    </>
                )}
            </div>

            <p className={`analyse-short-description`}>
                Generated with{" "}
                <Link
                    target="_blank"
                    className={`feedgram-link`}
                    to="/topic-analysis"
                >
                    Feedgram Anvanced Topic Analysis.
                </Link>
            </p>
        </div>
    );
}

export default KeywordContainer;
